"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSwiftBicMatchingCountry = exports.isIbanMatchingCountry = void 0;
const frenchDomTomCountryCode_1 = require("../constants/frenchDomTomCountryCode");
const getCountryCode_1 = require("./getCountryCode");
const validateCountryCode = (ibanBicCountryCode, countryCode) => {
    if (ibanBicCountryCode === countryCode) {
        return true;
    }
    if (countryCode === 'FR') {
        // French DOM-TOMs can have a different country code but should still
        // be validated as "FR".
        return frenchDomTomCountryCode_1.FRENCH_DOM_TOM_COUNTRIES_CODES.includes(ibanBicCountryCode);
    }
    return false;
};
/**
 * Check if the iban matches the country code
 * @param {Object} args
 * @param {string} args.countryCode - The country code
 * @param {string} args.iban - The iban
 * @returns {boolean} - Whether the iban matches the country code
 */
const isIbanMatchingCountry = ({ countryCode, iban, }) => {
    const ibanCountryCode = (0, getCountryCode_1.getCountryCodeFromIban)(iban);
    return validateCountryCode(ibanCountryCode, countryCode);
};
exports.isIbanMatchingCountry = isIbanMatchingCountry;
/**
 * Check if the swiftBic matches the country code
 * @param {Object} args
 * @param {string} args.countryCode - The country code
 * @param {string} args.swiftBic - The swiftBic
 * @returns {boolean} - Whether the swiftBic matches the country code
 */
const isSwiftBicMatchingCountry = ({ countryCode, swiftBic, }) => {
    const swiftBicCountryCode = (0, getCountryCode_1.getCountryCodeFromSwiftBic)(swiftBic);
    return validateCountryCode(swiftBicCountryCode, countryCode);
};
exports.isSwiftBicMatchingCountry = isSwiftBicMatchingCountry;
